/*
	Generated on 07/05/2025 by UI Generator PRICES-IDE
	https://amanah.cs.ui.ac.id/research/ifml-regen
	version 3.9.0
*/
import React from 'react';
import { Link, useNavigate } from "react-router";
import { useParams } from "@/commons/hooks/useParams"

import { useAuth } from '@/commons/auth';
import { Button, Modal,Spinner } from '@/commons/components';


import deleteMataKuliah from '../services/deleteMataKuliah'


import deletemembergrupMataKuliah from '../services/deletemembergrupMataKuliah'

import * as Layouts from "@/commons/layouts";

const GrupTable = ({ grupMataKuliahDataList,
		 

	}) => {
  const { checkPermission } = useAuth();
  
  
  const [selectedKonfirmasiHapusMataKuliahdiDalamGrup, setSelectedKonfirmasiHapusMataKuliahdiDalamGrup] = React.useState(null);
  
  
  	const { 	grupMataKuliahId } = useParams();
  
  const [showModalKonfirmasiHapusMataKuliah, setShowModalKonfirmasiHapusMataKuliah] = React.useState(false);
  
  const navigate = useNavigate(); 
  
  	
  const hapus = async (selectedKonfirmasiHapusMataKuliah) => {
    await deleteMataKuliah({
      Id: selectedKonfirmasiHapusMataKuliah.Id,
    });
    window.location.reload()
  }
const [showModalKonfirmasiHapusMataKuliahdiDalamGrup, setShowModalKonfirmasiHapusMataKuliahdiDalamGrup] = React.useState(false);



  
  const hapusMemberGrup = async (selectedKonfirmasiHapusMataKuliahdiDalamGrup) => {
    await deletemembergrupMataKuliah({
      id: selectedKonfirmasiHapusMataKuliahdiDalamGrup.id,
    });
    window.location.reload()
  }
const [showModalKonfirmasiHapusGrupMataKuliah, setShowModalKonfirmasiHapusGrupMataKuliah] = React.useState(false);



  
  const hapusGrup = async (selectedKonfirmasiHapusGrupMataKuliah) => {
    await deleteAllMemberMataKuliah({
      grupMataKuliahId: selectedKonfirmasiHapusGrupMataKuliah.grupMataKuliahId,
    });
    navigate('/matakuliah/:id');
  }
  
  return (
  <>
    <Layouts.ListComponentTableLayout
  	  items={[grupMataKuliahDataList]}
  	  itemsAttrs={[
          {
            id: "kodeMataKuliah",
            condition: "",
            label: "Kode Mata Kuliah",
  		  featureName: "kode",
            editable: false
          }
  ,
          {
            id: "kodeKurikulum",
            condition: "",
            label: "Kode Kurikulum",
  		  featureName: "kurikulumKode",
            editable: false
          }
  ,
          {
            id: "namaMataKuliah",
            condition: "",
            label: "Nama Mata Kuliah",
  		  featureName: "nama",
            editable: false
          }
  ]}
        itemsEvents={(groupItem) => [
          checkPermission("DeleteGrupMataKuliah") &&  (
          <Link to=''>
            <Button
              size="sm"
              variant=
                          "danger"
              onClick={() => {
                setSelectedKonfirmasiHapusMataKuliahdiDalamGrup(groupItem);
                setShowModalKonfirmasiHapusMataKuliahdiDalamGrup(true);
              }}
            >
              Hapus dari Grup
            </Button>
          </Link>
          )
          
        ]}
        itemsModals={(groupItem) => [
          <Modal
  		isShow={showModalKonfirmasiHapusMataKuliah}
  		title={"Konfirmasi Hapus Mata Kuliah"}
  		text={"Are you sure want to proceed?"}
  		>
  		
  		
  		
  		
  		
  				<Link to=''><Button className={`w-full`} variant="tertiary" onClick={() => setShowModalKonfirmasiHapusMataKuliah(false)}>Batal</Button></Link>
  		
  		<Button
  		  variant="danger"
  		  onClick={() => hapus(selectedKonfirmasiHapusMataKuliah)}
  		>
  		  Hapus
  		</Button>
  		</Modal>
  		,
  		<Modal
  		isShow={showModalKonfirmasiHapusMataKuliahdiDalamGrup}
  		title={"Konfirmasi Hapus Mata Kuliah di Dalam Grup"}
  		>
  		
  		
  		
  		
  		
  				<Link to=''><Button className={`w-full`} variant="tertiary" onClick={() => setShowModalKonfirmasiHapusMataKuliahdiDalamGrup(false)}>Batal</Button></Link>
  		
  		<Button
  		  variant="danger"
  		  onClick={() => hapusMemberGrup(selectedKonfirmasiHapusMataKuliahdiDalamGrup)}
  		>
  		  Hapus
  		</Button>
  		</Modal>
  		,
  		<Modal
  		isShow={showModalKonfirmasiHapusGrupMataKuliah}
  		title={"Konfirmasi Hapus Grup Mata Kuliah"}
  		>
  		
  		
  		
  		
  		
  				<Link to=''><Button className={`w-full`} variant="tertiary" onClick={() => setShowModalKonfirmasiHapusGrupMataKuliah(false)}>Batal</Button></Link>
  		
  		<Button
  		  variant="danger"
  		  onClick={() => hapusGrup(selectedKonfirmasiHapusGrupMataKuliah)}
  		>
  		  Hapus
  		</Button>
  		</Modal>
                  
                ]}
  	/>

  		
  </>
  )
};

export default GrupTable;
